import React from 'react';
import { Github, Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="relative bg-ink-950 border-t border-white/5 py-8 font-body">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-white/40 font-mono">
          © {year} Muhammad Tauqeer — built with React &amp; a bit too much coffee.
        </p>
        <div className="flex items-center gap-4">
          <a
            href="https://github.com/mtauqeer248"
            target="_blank"
            rel="noopener noreferrer"
            className="interactive text-white/40 hover:text-mint-300 transition-colors"
            aria-label="GitHub"
          >
            <Github className="w-4 h-4" />
          </a>
          <a
            href="https://www.linkedin.com/in/muhammad-tauqeer-react-developer/"
            target="_blank"
            rel="noopener noreferrer"
            className="interactive text-white/40 hover:text-mint-300 transition-colors"
            aria-label="LinkedIn"
          >
            <Linkedin className="w-4 h-4" />
          </a>
          <a
            href="mailto:Tauqeer248@gmail.com"
            className="interactive text-white/40 hover:text-mint-300 transition-colors"
            aria-label="Email"
          >
            <Mail className="w-4 h-4" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
